module.exports = __webpack_public_path__ + "media/images/icon-header-7c595c72913978ca6749a966d2667176.png";